import { Schedule } from "./schedule.interface";

export class ScheduleSet {
  summerList: Schedule;
  winterList: Schedule;
  thereIsWinter: boolean;
  winterStartMinutes: number;
  winterStartMinutesShow: number;
}

